import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filtered: false,
  success: false,
  selectedRecord: null,
  company: [],
  form: [],
  levelGroup: [],
  org: [],
  position: [],
  emp: [],
  lineChart: [],
  tableData: [],
  appraisalType: [],
  structure: [],
  loadingStates: []
}

// fetchCompany

const fetchCompanyStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'company_id'] }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    message: action.errorMessage
  }
}

// fetchForm

const fetchFormStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'form_id'] }
}

const fetchFormSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'form_id'),
    form: action.data
  }
}

const fetchFormFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'form_id'),
    message: action.errorMessage
  }
}

const fetchStructureStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'structure_id'] }
}

const fetchStructureSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'structure_id'),
    structure: action.data
  }
}

const fetchStructureFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'structure_id'),
    message: action.errorMessage
  }
}

// fetchLevelGroup

const fetchLevelGroupStart = (state, action) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'level_group_id']
  }
}

const fetchLevelGroupSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'level_group_id'),
    levelGroup: action.data
  }
}

const fetchLevelGroupFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'level_group_id'),
    message: action.errorMessage
  }
}

// fetchOrg

const fetchOrgStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'org_id'] }
}

const fetchOrgSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    org: action.data
  }
}

const fetchOrgFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    message: action.errorMessage
  }
}

// fetchPosition

const fetchPositionStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'position_id'] }
}

const fetchPositionSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_id'),
    position: action.data
  }
}

const fetchPositionFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_id'),
    message: action.errorMessage
  }
}

// fetchEmp

const fetchEmpStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'emp_id'] }
}

const fetchEmpSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id'),
    emp: action.data
  }
}

const fetchEmpFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id'),
    message: action.errorMessage
  }
}

// fetchAppraisalType

const fetchAppraisalTypeStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'value_list_id'] }
}

const fetchAppraisalTypeSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'value_list_id'),
    appraisalType: action.data
  }
}

const fetchAppraisalTypeFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'value_list_id'),
    message: action.errorMessage
  }
}

// fetchDashboardPerformanceComparisonChartLine

const fetchDashboardPerformanceComparisonChartLineStart = (state, action) => {
  return {
    ...state,
    loading: true,
    filtered: false
  }
}
const fetchDashboardPerformanceComparisonChartLineSuccess = (state, action) => {
  const { records } = action
  const { line_chart, table_data } = records
  return {
    ...state,
    loading: false,
    filtered: true,
    lineChart: line_chart,
    tableData: table_data
  }
}
const fetchDashboardPerformanceComparisonChartLineFailed = (state, action) => {
  return {
    ...state,
    filtered: false,
    loading: false
  }
}

// fetchDashboardPerformanceComparisonChartBar

const fetchDashboardPerformanceComparisonChartBarStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}
const fetchDashboardPerformanceComparisonChartBarSuccess = (state, action) => {
  const { records } = action
  const { bar_chart, percent_change } = records
  return {
    ...state,
    loading: false,
    barChart: bar_chart,
    percentChange: percent_change
  }
}
const fetchDashboardPerformanceComparisonChartBarFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

// fetchDashboardPerformanceComparisonDataKpi

const fetchDashboardPerformanceComparisonDataKpiStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}
const fetchDashboardPerformanceComparisonDataKpiSuccess = (state, action) => {
  let { records } = action
  return {
    ...state,
    loading: false,
    records: records
  }
}
const fetchDashboardPerformanceComparisonDataKpiFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH_COMPANY_OPTIONS
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    // FETCH_FORM_OPTIONS
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_START:
      return fetchFormStart(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchFormSuccess(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchFormFailed(state, action)
    // FETCH_STRUCTURE_OPTIONS
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_START:
      return fetchStructureStart(state, action)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchStructureSuccess(state, action)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchStructureFailed(state, action)
    // FETCH_LEVEL_GROUP_OPTIONS
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_START:
      return fetchLevelGroupStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchLevelGroupSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchLevelGroupFailed(state, action)
    // FETCH_ORGANIZATION_OPTIONS
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START:
      return fetchOrgStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchOrgSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchOrgFailed(state, action)
    // FETCH_POSITION_OPTIONS
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_START:
      return fetchPositionStart(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchPositionSuccess(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchPositionFailed(state, action)
    // FETCH_EMPLOYEE_OPTIONS
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_START:
      return fetchEmpStart(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_SUCCESS:
      return fetchEmpSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FAILED:
      return fetchEmpFailed(state, action)
    // FETCH_APPRAISAL_TYPE_OPTIONS
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_START:
      return fetchAppraisalTypeStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchAppraisalTypeSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchAppraisalTypeFailed(state, action)
    // FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_START:
      return fetchDashboardPerformanceComparisonChartLineStart(state, action)
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_SUCCESS:
      return fetchDashboardPerformanceComparisonChartLineSuccess(state, action)
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_FAILED:
      return fetchDashboardPerformanceComparisonChartLineFailed(state, action)
    // FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_START:
      return fetchDashboardPerformanceComparisonChartBarStart(state, action)
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_SUCCESS:
      return fetchDashboardPerformanceComparisonChartBarSuccess(state, action)
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_FAILED:
      return fetchDashboardPerformanceComparisonChartBarFailed(state, action)
    //FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_START:
      return fetchDashboardPerformanceComparisonDataKpiStart(state, action)
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_SUCCESS:
      return fetchDashboardPerformanceComparisonDataKpiSuccess(state, action)
    case actionTypes.FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_FAILED:
      return fetchDashboardPerformanceComparisonDataKpiFailed(state, action)

    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState } // DEFAULT
    default:
      return state
  }
}

export default reducer
